<template>
  <div>
    <div v-for="ftype in fileTypes" :key="ftype.id">
      <div class="md-layout">
        <md-card
          v-if="!ftype.need_bill || (ftype.need_bill && provider.does_bill)"
          class="md-layout-item md-medium-size-100 md-small-size-100 md-xsmall-size-100"
        >
          <md-card-header>
            <h3>{{ ftype.name }}</h3>
          </md-card-header>
          <md-card-content>
            <input
              multiple
              type="file"
              class="inputfile"
              :name="ftype.name"
              :id="`input${ftype.id}`"
              :ref="ftype.id"
              @change="listFiles(ftype.id)"
            />
            <label :for="`input${ftype.id}`"> Selecciona archivos </label>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-25 mx-auto">
        <md-button
          class="md-success"
          :to="`/provider/${provider.provider_number}`"
        >
          Finalizar
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
  import catalogService from '@/services/catalog'
  import { SlideYDownTransition } from 'vue2-transitions'

  export default {
    name: 'ThirdStep',
    components: { SlideYDownTransition },
    props: {
      provider: {
        type: Object,
        required: true,
        default: {
          id: 1,
          does_bill: true,
          provider_number: 'PM001',
        },
      },
    },
    data() {
      return {
        test: [],
        fileTypes: [],
        files: [],
      }
    },
    mounted() {
      catalogService.fetch('provider_file_types').then(res => this.fileTypes = res)
    },
    methods: {
      getFileType(name) {
        return this.fileTypes.find(fType => fType.name === name)
      },
      buildData(files, fileType) {
        let data = []
        let prov = this.provider.id

        for (let i = 0; i < files.length; i++) {
          let f = files[i]

          let formData = new FormData()
          formData.append('file', f)
          formData.append('provider', prov)
          formData.append('file_type', fileType.id)

          data.push(formData)
        }
        return data
      },
      listFiles(ref) {
        let fileList = this.$refs[ref][0].files
        let fType = this.getFileType(this.$refs[ref][0].name)
        let data = this.buildData(fileList, fType)

        this.uploadFiles(data)
      },
      uploadFiles(data) {
        let filesUploaded = []

        data.forEach(el => {
          filesUploaded.push(this.sendFiles(el))
        })

        Promise.all(filesUploaded)
          .then(() => (this.$successMessage({title: '¡Archivos cargados con éxito!'})))
          .catch(this.$fireErrorResponse)
      },
      sendFiles(tData) {
        return this.$http.post('/catalogs/providers/files/', tData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
      },
    },
  }
</script>

<style lang="css" scoped>
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.inputfile + label {
  font-size: 1.25em;
  font-weight: 700;
  color: #fff;
  background-color: #4caf50;
  display: inline-block;
  cursor: pointer;
  width: 100%;
  padding: 1em;
  border: 1px solid green;
  border-radius: 5px;
  text-align: center;
}

.inputfile:focus + label,
.inputfile + label:hover {
  background-color: #47a44b;
}

.inputfile:focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}

.inputfile + label * {
  pointer-events: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/Providers/wizard/ThirdStep.vue